module.exports = __webpack_public_path__ + "img/01beijing2.958f8679.png";